import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DocumentRequestDashboardRoutingModule } from './document-request-dashboard-routing.module';
import {CoreModule} from "../../core/core.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule} from "@angular/forms";
import {AutoCompleteModule} from "primeng/autocomplete";
import {TableModule} from "primeng/table";
import {CalendarModule, CheckboxModule, MultiSelectModule, TreeTable, TreeTableModule,DropdownModule} from "primeng/primeng";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {DocumentRequestDashboardComponent} from "./document-request-dashboard.component";

@NgModule({
  imports: [

    CommonModule,
    DocumentRequestDashboardRoutingModule,
    DropdownModule,
    CoreModule,
    NgbModule,
    FormsModule,
    AutoCompleteModule,
    TableModule,
    TreeTableModule,
    TranslateModule,
    MultiSelectModule,
    CalendarModule,
    CheckboxModule
  ],
  exports: [
    DocumentRequestDashboardComponent
  ],
  declarations: [DocumentRequestDashboardComponent]
})
export class DocumentRequestDashboardModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request-dashboard/document-request-dashboard.module.ts